import { Box } from "@mui/material";
import React from "react";
import useSubscription from "../../../../hooks/useSubscription";
import Searchbar from "../../../components/searchbar/Searchbar";
import SubscriptionTable from "../../../components/SubscriptionTable/SubscriptionTable";
import classes from "./subscription.module.css";

const Subscription = () => {
   const { searchSubscription } = useSubscription();
   return (
      <Box sx={{ width: "100%" }}>
         <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <p>Subscription Payment History</p>
         </Box>

         <div className={classes.buttons}>
            <Searchbar
               label="Search by username"
               onSearchFunction={searchSubscription}
            />
         </div>

         <SubscriptionTable />
      </Box>
   );
};

export default Subscription;
